/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ManifestType } from './ManifestType';
import type { StorageTier } from './StorageTier';
import type { StorageTierStatus } from './StorageTierStatus';

export type DataAssetSearchParameters = {
    query?: string;
    sealog_event_query?: string;
    exclude?: string;
    regex?: boolean;
    file_extensions?: Array<string>;
    directory?: string;
    parent_prefix?: string;
    include_descendant_deployments?: boolean;
    squash_by_path?: boolean;
    data_set_public_ids?: Array<string>;
    data_asset_public_ids?: Array<string>;
    manifest_types?: Array<ManifestType>;
    manifest_public_ids?: Array<string>;
    real_asset_public_ids?: Array<string>;
    real_asset_deployment_public_ids?: Array<string>;
    excluded_real_asset_deployment_public_ids?: Array<string>;
    storage_tiers?: Array<StorageTier>;
    storage_tier_statuses?: Array<StorageTierStatus>;
    sealog_event_values?: Array<string>;
    sealog_event_free_texts?: Array<string>;
    sealog_event_option_names?: Array<string>;
    sealog_event_option_values?: Array<string>;
    record_modified_before?: string;
    record_modified_after?: string;
    asset_modified_before?: string;
    asset_modified_after?: string;
    sort_field?: DataAssetSearchParameters.sort_field;
    sort_order?: DataAssetSearchParameters.sort_order;
};

export namespace DataAssetSearchParameters {

    export enum sort_field {
        ASSET_UPDATED_DT = 'asset_updated_dt',
        RECORD_UPDATED_DT = 'record_updated_dt',
        PATH = 'path',
    }

    export enum sort_order {
        ASC = 'asc',
        DESC = 'desc',
    }


}

